import { render, staticRenderFns } from "./keyProjectCompleteRegionPage.vue?vue&type=template&id=4ff36bc1&scoped=true&"
import script from "./keyProjectCompleteRegionPage.vue?vue&type=script&lang=js&"
export * from "./keyProjectCompleteRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./keyProjectCompleteRegionPage.vue?vue&type=style&index=0&id=4ff36bc1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff36bc1",
  null
  
)

export default component.exports